module.exports = __webpack_public_path__ + "static/logo-gp20-homepage-transparent-a2096e33de4b71f85860fc05dcadd4e7.png";